import { SalesOrderComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1322. 受注案件コメント編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  content: string;
  content_json: string;
};
const updateSalesOrderComment = (props: Props): Promise<SalesOrderComment> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_comments/${props.id}`, props);
};
export const useUpdateSalesOrderComment = () => {
  return useMutation({
    mutationFn: updateSalesOrderComment,
  });
};
